import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Capital Projects: A long-term infrastructure investment, such as a building or renovation.',
    name: 'Capital Projects',
    partialId: PartialId.Standard.create('cap_projs'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
